// src/app.routes.ts
import { Routes } from '@angular/router';

import { AppLayout } from './app/layout/component/app.layout';
import { Dashboard } from './app/pages/dashboard/dashboard.component';
import { Landing } from './app/pages/landing/landing';
import { Notfound } from './app/pages/notfound/notfound';
import { Login } from './app/pages/auth/login/login.component';
import { CostAnalysisComponent } from './app/pages/cost-metrics/cost-analysis/cost-analysis';
import { costMetrics } from './app/pages/cost-metrics/cost-metrics.component';
import { aboutComponent } from './app/pages/about/about';
import { TrendComponent } from './app/pages/trend/trend';
import { homeComponent } from './app/pages/home/home';
import { resourceComponent } from './app/pages/resources/resources';
import { T0DashboardComponent } from './app/pages/t0-dashboard/t0-dashboard.component';
import { ModelNavigatorComponent } from './app/pages/model-navigator/model-navigator.component';

import { TierAccessGuard } from './app/core/shared/tier-access.guard';
import { FileUploadComponent } from './app/pages/file-upload/file-upload.component';
import { T3DashboardComponent } from './app/pages/t3-dashboard/t3-dashboard.component';
import { adminDashboardAccessGuard } from './app/pages/admin-dashboard/admin-dashboard-access.guard';
import { AdminDashboardComponent } from './app/pages/admin-dashboard/admin-dashboard.component';
import { MsalGuard } from '@azure/msal-angular';

export const appRoutes: Routes = [
  { path: 'login', component: Login, pathMatch: 'full' },
  { path: 'landing', component: Landing },

  { path: '', redirectTo: 'login', pathMatch: 'full' },

  {
    path: '',
    component: AppLayout,
    canActivate: [MsalGuard],
    children: [
      {
        path: 'admin-dashboard',
        component: AdminDashboardComponent,
        // canActivate: [adminDashboardAccessGuard],
        data: { title: 'Admin Dashboard', showSimulation: false, showLabelInLayout: false }
      },

      {
        path: 't6-dashboard',
        component: Dashboard,
        canActivate: [TierAccessGuard],
        data: { tier: 't6', title: 'T6 Dashboard', showSimulation: true, showLabelInLayout: true }
      },

      {
        path: 't0-dashboard',
        component: T0DashboardComponent,
        canActivate: [TierAccessGuard],
        data: { tier: 't0', title: 'T0-Dashboard', showSimulation: false, showLabelInLayout: false }
      },

      {
        path: 'enhanced-simulator',
        component: T3DashboardComponent,
        // canActivate: [TierAccessGuard],
        data: { tier: 't3', title: 'T3 Dashboard', showSimulation: false, showLabelInLayout: false }
      },

      { path: 'home', component: homeComponent, data: { title: '', showSimulation: false, showLabelInLayout: true } },
      { path: 'cost-metrics', component: CostAnalysisComponent, data: { title: 'Cost Analysis', showSimulation: true, showLabelInLayout: true } },
      { path: 'economy-analysis', component: costMetrics, data: { title: 'Economy Analysis', showSimulation: true, showLabelInLayout: false } },
      { path: 'about', component: aboutComponent, data: { title: '', showSimulation: false, showLabelInLayout: true } },
      { path: 'trend', component: TrendComponent, data: { title: 'Trend Over Time', showSimulation: false, showLabelInLayout: true } },
      { path: 'resources', component: resourceComponent, data: { title: 'Resources', showSimulation: false, showLabelInLayout: false } },
      { path: 'model-navigator', component: ModelNavigatorComponent, data: { title: 'Modal Navigator', showSimulation: false, showLabelInLayout: false } },
      { path: 'file-upload', component: FileUploadComponent, data: { title: 'File Upload', showSimulation: false, showLabelInLayout: false } },
      { path: 'pages', loadChildren: () => import('./app/pages/pages.routes') }
    ]
  },

  { path: 'notfound', component: Notfound },
  { path: '**', redirectTo: '/notfound' }
];